import { Toaster } from "@/components/ui/sonner";
import useReveal from "@/hooks/useReveal";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import CountryStrip from "@/components/site/CountryStrip";
import Storytelling from "@/components/site/Storytelling";
import Blog from "@/components/site/Blog";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useReveal([]);

  return (
    <div className="min-h-screen bg-white font-body text-[#1e293b]">
      <Header />
      <main>
        <Hero />
        <CountryStrip />
        <Storytelling />
        <Blog />
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
}
